
import style from './estagioLayout.module.css'
import React from "react";
import { useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Form, Label, FormGroup, Input, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Checkmark } from 'react-checkmark'
import { FaExclamationCircle } from 'react-icons/fa';

import axios from 'axios';

function EstagioLayout() {
    const navigate = useNavigate();
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    

    const [modal_C, setModal_C] = useState(false);
    const toggle_C = () => setModal_C(!modal_C);

    const [modal_C2, setModal_C2] = useState(false);
    const toggle_C2 = () => setModal_C2(!modal_C2);

    const [modal_Confirmar, setModal_Confirmar] = useState(false);

    const [isConvoqueModalOpen, setIsConvoqueModalOpen] = useState(false);
    const [VagaData, setVagaData] = useState({Nome_Empresa:""});


    const handleCandidatura = (VagaData) => {

      if (modal_Confirmar) {
        handleConfirmarModal();
      }else if(isConvoqueModalOpen){
        handleCloseModal();
      }
      setIsConvoqueModalOpen(false);

      const dadosCandidatura = {

          estagio_id: VagaData.idVaga,
          id_Usuario: userInfo.idEstudantes,
          Email_Empresa: VagaData.Email_Empresa,
          Nome_Usuario: userInfo.Nome_Estudante,
          curso: userInfo.curso.Nome_Curso,
          Email_Estudante: userInfo.Email_Estudante,

      };


      axios.post('https://linkestagio.com.br/App.php?operation=cadastro-usuario-vaga1', dadosCandidatura)
        .then((response) => {
          console.log(response)
          if (typeof response.data === 'string' && response.data.includes('Fatal error') 
          && response.data.includes('Duplicate entry')) {
            toggle_C2();

          }else{
            toggle_C()
            axios.post('https://linkestagio.com.br/App.php?operation=cadastro-usuario-vaga2', dadosCandidatura)
            
            .then((response) => {
            });
          }

        })
        .catch((error) => {
          console.error('Erro ao se candidatar:', error);
        });
  };

  const [modal_S, setModal_S] = useState(false);
  const toggle_S = () => setModal_S(!modal_S);

  const redirectToConfig = () => {
    navigate('/configEstudante');
  };

  useEffect(() => {

    if (userInfo.Curriculo === ""  || userInfo.Curriculo === null) {
      toggle_S()
    }
  }, []);

  const toggle_Confirmar = (idVaga) => {
    const estagioEncontrado = estagioList.find(estagio => estagio.idVaga === idVaga);
    setVagaData(estagioEncontrado);
    setModal_Confirmar(!modal_Confirmar);
  };

  const handleConfirmarModal = () => {
    // Resetar VagaData para o estado inicial ou para um estado vazio/default
    setVagaData({ Nome_Empresa: "" ,Semestre_Inicial: "" ,Semestre_Final: "" ,Carga_Horaria: "" ,
    Atividades: "" ,Remuneracao: "" ,Horario_Estagio: "" ,Periodo_Estagio: "" ,
    Rua: "" ,Numero: "" ,Complemento: "" ,Bairro: "" ,VagaData: "",Email_Empresa:""}); // ou qualquer outro estado inicial que você considerar adequado
    // Fechar o modal
    setModal_Confirmar(false);
  };



  const toggleConvoqueModal = (idVaga) => {
    const estagioEncontrado = estagioList.find(estagio => estagio.idVaga === idVaga);
    setVagaData(estagioEncontrado);

    setIsConvoqueModalOpen(!isConvoqueModalOpen);
  };

  const handleCloseModal = () => {
    // Resetar VagaData para o estado inicial ou para um estado vazio/default
    setVagaData({ Nome_Empresa: "" ,Semestre_Inicial: "" ,Semestre_Final: "" ,Carga_Horaria: "" ,
    Atividades: "" ,Remuneracao: "" ,Horario_Estagio: "" ,Periodo_Estagio: "" ,
    Rua: "" ,Numero: "" ,Complemento: "" ,Bairro: "" ,VagaData: "",Email_Empresa:""}); // ou qualquer outro estado inicial que você considerar adequado

    setIsConvoqueModalOpen(false);
  };
    
  function verificarCEP_Vaga(numero, faixaCEP) {
    const [inicio, fim] = faixaCEP.split('-');
    return parseInt(inicio, 10) <= numero && numero <= parseInt(fim, 10);
}
    
    useEffect(() => {

      const RAIO_CEP = 900;

      let CEP_Estudante = null;
      let Semestre_Estudante = null;

      if (userInfo?.CEP_Estudante) {
        CEP_Estudante = parseInt(userInfo.CEP_Estudante.substring(0, 5), 10);
      }

      if (userInfo?.Semestre_Estudante) {
        Semestre_Estudante = parseInt(userInfo.Semestre_Estudante, 10);
      }

      axios.post(
        'https://linkestagio.com.br/App.php?operation=get-todas-vagas',
        { idCurso: userInfo?.curso?.idCurso }
      )
      .then(response => {

        // Se não tem CEP do estudante, retorna tudo
        if (!CEP_Estudante) {
          setEstagioList(response.data);
          return;
        }

        const prefixoEstadoEstudante = String(CEP_Estudante).substring(0, 2);

        const Vagas_Usuario = [];

        for (let i = 0; i < response.data.length; i++) {

          const vaga = response.data[i];

          if (!vaga.CEP) continue;

          const CEP_Vaga = parseInt(vaga.CEP.substring(0, 5), 10);

          // ✅ REGRA DO RAIO 2000 (igual PHP)
          if (Math.abs(CEP_Estudante - CEP_Vaga) > RAIO_CEP) {
            continue;
          }

          const Semestre_Inicial = parseInt(vaga.Semestre_Inicial, 10);
          const Semestre_Final   = parseInt(vaga.Semestre_Final, 10);

          // ✅ REGRA DO SEMESTRE (igual PHP)
          if (
            isNaN(Semestre_Estudante) ||
            (
              Semestre_Inicial === 0 && Semestre_Final === 0
            ) ||
            (
              Semestre_Estudante >= Semestre_Inicial &&
              Semestre_Estudante <= Semestre_Final
            )
          ) {
            Vagas_Usuario.push(vaga);
          }
        }

        setEstagioList(Vagas_Usuario);
      })
      .catch(error => {
        console.error('Erro:', error);
      });

    }, []);

    const [estagioList, setEstagioList] = useState([])

    return (
      <>
      {estagioList.length > 0 ? (
      <div className={style.AreaCardTitle}>
        <p className={style.AreaTitle}>Encontre aqui sua oportunidade de estágio!</p>
      </div>
      ) : (
        <div className={style.AreaCardTitle}>
        <p className={style.AreaTitle2}>No momento não há oportunidades de estágio disponíveis com o seu perfil
        (curso, ano, semestre ou cidade)</p>
        <p className={style.AreaTitle2}>Em breve, novas vagas!</p>
    </div>
      )}

      <div className={style.AreaCard}>      
        {estagioList.map((estagio) => (
            <div key={estagio.id} >
              <div className={style.cardBody}>
              <p className={`${style.cardTitle}`}>Vaga - N° {parseInt(500) + parseInt(estagio.idVaga, 10)}</p>
                <p className={`${style.cardInfo}`}>Empresa: {estagio.Nome_Empresa}</p>
                <p className={`${style.cardInfo}`}>
                  Bolsa auxílio: R${
                  estagio.Remuneracao 
                  ? parseFloat(estagio.Remuneracao).toLocaleString('pt-BR', {
                      style: 'decimal',
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  : '0,00'
                }                
                </p>                

                {userInfo.curso.Nome_Curso !== "Ensino Médio" && <p className={`${style.cardInfo}`}>Semestre: {estagio.Semestre_Inicial} ao {estagio.Semestre_Final}</p>}
                <p className={`${style.cardInfo}`}>Período: {estagio.Periodo_Estagio}</p>
                <p className={`${style.cardInfo}`}>Cidade: {estagio.Cidade} - {estagio.Estado}</p>
                <p className={`${style.cardInfo}`}>Bairro: {estagio.Bairro}</p>
                <p
                    className={`${style.optionNav}`}  onClick={() => toggleConvoqueModal(estagio.idVaga)}
                >
                    Ver Mais Informações
                </p>
                <p className={`${style.optionNav3}`} onClick={() => toggle_Confirmar(estagio.idVaga)}>Candidatar para Vaga</p>
              </div>
            </div>
          ))}
          </div>
          <Modal isOpen={isConvoqueModalOpen} size='lg' toggle={handleCloseModal}>
          
          <ModalHeader style={{borderBottom: 'none' }} toggle={handleCloseModal}>
            <h1 className="form-title">Informações da Vaga {parseInt(500) + parseInt(VagaData.idVaga, 10)}:</h1>
          </ModalHeader>

            <ModalBody>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Empresa: {VagaData.Nome_Empresa}</p>
                {VagaData.Site_vaga && (
                  <p style={{ marginTop: '6px', fontWeight: '600', color: 'black' }}>
                    Site:{' '}
                    <a
                      href={
                        VagaData.Site_vaga.startsWith('http')
                          ? VagaData.Site_vaga
                          : `https://${VagaData.Site_vaga}`
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#D96F66', textDecoration: 'none' }}
                    >
                      {VagaData.Site_vaga}
                    </a>
                  </p>
                )}
                {VagaData.Instagram_vaga && (
                <p style={{ marginTop: '6px', fontWeight: '600', color: 'black' }}>
                  Instagram:{' '}
                  <a
                    href={
                      VagaData.Instagram_vaga.startsWith('http')
                        ? VagaData.Instagram_vaga
                        : `https://instagram.com/${VagaData.Instagram_vaga.replace(
                            /^@/,
                            ''
                          )}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#D96F66', textDecoration: 'none' }}
                  >
                    {VagaData.Instagram_vaga}
                  </a>
                </p>
              )}
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Cidade: {VagaData.Cidade} - {VagaData.Estado}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Endereço: {VagaData.Rua}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Bairro: {VagaData.Bairro}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Número: {VagaData.Numero}</p>
                {VagaData.Complemento && (
                  <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>
                    Complemento: {VagaData.Complemento}
                  </p>
                )}
              
                {userInfo.curso.Nome_Curso !== "Ensino Médio" && <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Semestres Desejados: {VagaData.Semestre_Inicial} ao {VagaData.Semestre_Final}</p>}
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Carga Horária: {VagaData.Carga_Horaria}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Atividades a serem realizadas: {VagaData.Atividades}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Remuneração: R$: {VagaData.Remuneracao}{VagaData.Vale_Alimentacao !== "" && ` + Vale Alimentação (R$: ${VagaData.Vale_Alimentacao})`}{VagaData.Vale_Transporte !== "" && ` + Vale Transporte (R$: ${VagaData.Vale_Transporte})`}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Horário do Estágio: {VagaData.Horario_Estagio}</p>
                <p style={{marginTop: '6px', fontWeight: '600', color: 'black'}}>Periodo: {VagaData.Periodo_Estagio}</p>

              <div className={style.Sidecontainer}>
                <Button className={style.Cancelar} variant="custom" onClick={() => toggle_Confirmar(VagaData.idVaga)}>Candidatar para a Vaga</Button>
               </div>

            </ModalBody>
        </Modal>

        <Modal isOpen={modal_Confirmar} toggle={handleConfirmarModal} className="modal-form">
          <ModalHeader style={{borderBottom: 'none' }} toggle={handleConfirmarModal}>
          <h1 className="form-title">Confirmar Candidatura</h1>

          </ModalHeader>
            <ModalBody>
            <p className="form-description">Você está prestes se candidatar para a vaga {parseInt(500) + parseInt(VagaData.idVaga, 10)} na empresa {VagaData.Nome_Empresa}. 
            Antes de prosseguir, por favor, revise seu curriculo e certifique-se de que todos seus dados foram cadastrados corretamente.</p>
            
            <div className={style.Sidecontainer}>
              <Button className={style.Confirmar} variant="custom" onClick={() => handleCandidatura(VagaData)}>Confirmar</Button>
              <Button className={style.Cancelar} variant="custom" onClick={handleConfirmarModal}>Cancelar</Button>
            </div>

            </ModalBody>
        </Modal>

        <Modal isOpen={modal_S} onHide={() => { toggle_S(); redirectToConfig(); }} centered>
        <ModalHeader style={{ borderBottom: 'none' }} toggle={() => { toggle_S(); redirectToConfig(); }}>
        <h1 className="form-title">Opa, faltam alguns dados serem preenchidos em sua conta</h1>

        </ModalHeader>
          <ModalBody>
          <p className="form-description">Finalize o preenchimento dos seus dados para acessar a pagina de vagas, e não se esqueça de adicionar um currículo.</p>
          <Button className="login-button" variant="custom" onClick={() => { toggle_S(); redirectToConfig(); }}>Ir para o Meu Perfil</Button>
          </ModalBody>
      </Modal>

      <Modal isOpen={modal_C2} toggle={toggle_C2} className="modal-form">
        <ModalHeader style={{ borderBottom: 'none' }} toggle={toggle_C2}>

        </ModalHeader>
          <div className="d-flex flex-column align-items-center">
            <FaExclamationCircle size={96} color="#d24e42" />
          </div>

          <ModalBody>
          <br></br>
          <h1 className="form-title">Opa, você já se inscreveu nessa vaga!</h1>

          <p className="form-description">Verifique o seu e-mail para ver notificações do seu processo seletivo.</p>
          <Button className="login-button" variant="custom" onClick={toggle_C2}>Voltar para a página de vagas</Button>
          </ModalBody>
      </Modal>

      <Modal isOpen={modal_C} toggle={toggle_C} className="modal-form">
        <ModalHeader style={{ borderBottom: 'none' }} toggle={toggle_C}>

        </ModalHeader>
          <Checkmark size='64px' color='#2C7865' />

          <ModalBody>
          <br></br>
          <h1 className="form-title">Inscrição Realizado Com Sucesso!</h1>
          <p className="form-description">Sua chance de fazer parte de uma equipe que faz a diferença, em uma instituição que oferece não apenas um estágio, mas uma jornada de desenvolvimento pessoal e profissional.</p>
          <Button className="login-button" variant="custom" onClick={toggle_C}>Voltar para a página de vagas</Button>
          </ModalBody>
      </Modal>

      </>
    );

}


export default EstagioLayout;
